module.exports = __webpack_public_path__ + "img/WGLMR.8f5c2891.png";